<lib-card>
	Get the most from the app by using it on your phone / tablet.

	<lib-divider class="push-top push-bottom"></lib-divider>
	<mod-install-button [buttonType]="'primary'"></mod-install-button>
</lib-card>
@if (showAppStoreInfo()) {
<lib-card [title]="storeTitle()" class="push-top-md">
	<div>
		<p>
			Our decision to introduce {{ originalAppName() }} as a PWA rather than traditional native iOS and Android
			apps reflects our commitment to delivering a seamless and accessible fitness experience for everyone.
		</p>

		<p><strong>Here are some compelling reasons behind our choice:</strong></p>

		<ol>
			<li>
				<strong>Cross-Platform Compatibility:</strong> {{ originalAppName() }} PWA works effortlessly across all
				platforms, whether you're using an iOS device, an Android smartphone, or even a desktop browser. This
				universal accessibility ensures that you can access your fitness routines and track your progress no
				matter what device you prefer.
			</li>
			<li>
				<strong>Instant Accessibility:</strong> With {{ originalAppName() }} PWA, there's no need to download or
				install hefty app packages from the app stores. Simply visit our website, add {{ originalAppName() }} to
				your home screen, and voila! You have instant access to all the features and functionalities, saving you
				valuable time and device storage space.
			</li>
			<li>
				<strong>Seamless Updates:</strong> Unlike native apps that require manual updates through the app
				stores, {{ originalAppName() }} PWA automatically updates itself whenever you connect to the internet.
				This ensures that you're always using the latest version with bug fixes, performance improvements, and
				exciting new features without any hassle.
			</li>
			<li>
				<strong>Improved Performance:</strong> PWAs are known for their lightning-fast loading speeds and smooth
				user experiences, even on slower network connections. {{ originalAppName() }} PWA leverages these
				advantages to deliver a snappy and responsive fitness platform, allowing you to focus on your workouts
				without interruptions.
			</li>
			<li>
				<strong>Cost-Efficiency:</strong> Developing and maintaining separate native apps for iOS and Android
				can be costly and resource-intensive. By opting for a PWA approach, we can streamline development
				efforts, reduce overhead costs, and allocate more resources towards enhancing {{ originalAppName() }}'s
				features and expanding its reach.
			</li>
			<li>
				<strong>Enhanced Discoverability:</strong> Since PWAs are essentially websites, they are more
				discoverable through search engines, social media, and other online channels. This means that more
				people can easily find and access {{ originalAppName() }}, driving greater engagement and fostering a
				stronger sense of community within our platform.
			</li>
		</ol>

		<p>
			We believe that {{ originalAppName() }} PWA represents the future of mobile fitness, offering unparalleled
			convenience, performance, and accessibility for users worldwide. We're excited to embark on this journey
			with you and continue empowering individuals to lead healthier, happier lives through technology.
		</p>
		<p>Thank you for your continued support.</p>
	</div>
</lib-card>
}
